var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"edit-max-item"},[_c('div',{staticClass:"item-max selected"},[(_vm.maxSelected)?_c('span',[_vm._v("Esse produto ainda não tem um preço máximo definido")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"max-search"})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-21a129b5","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/record/stock/components/edit-max-item/EditMaxItem.vue
// module id = null
// module chunks = 